import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useRemoveConnectRequestMutation, useSendConnectRequestMutation } from 'services';
import { setModalConfig } from 'store/common';
import useTranslate from 'hooks/useTranslate';

interface ConnectBtnProps {
	isConnected: number; // 0, 1, 2
	userId: number;
	className?: string;
	handleConnectBtn?: any;
	show: boolean;
	btnFunc: boolean;
}

const ConnectBtn: React.FC<ConnectBtnProps> = ({
	isConnected = 0,
	userId,
	className = 'filled-btn rounded-pill lh-1',
	handleConnectBtn = () => {},
	show = false,
	btnFunc = true,
}) => {
	const { translate } = useTranslate();
	const [userConnected, setUserConnected] = useState<number>(isConnected || 0);

	const { mutateAsync: sendRequestMutation } = useSendConnectRequestMutation();
	const { mutateAsync: removeConnectionMutation } = useRemoveConnectRequestMutation();

	const removeConnection = async () => {
		const apiCalling = removeConnectionMutation;
		const res = await apiCalling(userId);
		if (res?.success) {
			setModalConfig({
				visible: false,
			});
			let status: number | null = null;
			switch (userConnected) {
				case 0:
					status = 2;
					break;
				case 2:
					status = 0;
					break;
			}
			if (handleConnectBtn) handleConnectBtn(status);

			setUserConnected((prev) => {
				if (prev === 0) return 2; // Requested
				if (prev === 2) return 0; // Reset to not connected
				return prev;
			});
		}
	};
	const handleConnectClick = async () => {
		if (userConnected === 2) return;
		const payload = userConnected === 1 ? userId : { id: userId };
		const apiCalling = userConnected === 1 ? removeConnectionMutation : sendRequestMutation;

		try {
			if (userConnected === 1) {
				setModalConfig({
					visible: true,
					type: 'confirmModal',
					id: userId,
					onClick: removeConnection,
					data: {
						title: translate('Modal.wantToRemoveConnection'),
					},
					props: {
						dialogClassName: 'confirm-modal',
					},
				});
			} else {
				const res = await apiCalling(payload);
				if (res?.success) {
					let status: number | null = null;
					switch (userConnected) {
						case 0:
							status = 2;
							break;
						case 2:
							status = 0;
							break;
					}
					if (handleConnectBtn) handleConnectBtn(status);

					setUserConnected((prev) => {
						if (prev === 0) return 2; // Requested
						if (prev === 2) return 0; // Reset to not connected
						return prev;
					});
				} else {
					console.error('Error handling connection request');
				}
			}
		} catch (err) {
			console.error('Error:', err);
		}
	};

	useEffect(() => {
		setUserConnected(isConnected);
	}, [isConnected]);

	if (!show) {
		return;
	}
	return (
		<Button
			className={`${className} ${userConnected === 1 ? 'transparent-btn' : userConnected === 2 ? 'gray-transparent-btn' : ''}`}
			{...(!btnFunc ? { onClick: handleConnectClick } : { onClick: handleConnectBtn })}
			// disabled={userConnected === 1}
		>
			{userConnected === 2
				? translate('Button.requested')
				: userConnected === 1
					? translate('Button.connected')
					: translate('Button.connect')}
		</Button>
	);
};

export default ConnectBtn;
